import React, { Context, createContext, useState, useContext } from 'react';
import { ISnackbar } from '../Types';
import Snackbar from '../components/BuildingBlocks/Snackbar/Snackbar';

const initialSnackBarState = {
  open: false,
  message: '',
  header: null,
  duration: null,
  type: null,
};

export const SnackbarContext: Context<ISnackbar> = createContext({
  show: (message, ms, alert) => {
    console.warn('No Snackbar Context Provided');
    console.log({ snackbar: { message, ms, alert } });
  },
});

export const useSnackbarContext = (): ISnackbar => useContext(SnackbarContext);

export function SnackbarProvider({ children }) {
  const [state, setState] = useState(initialSnackBarState);

  function handleClose() {
    setState({ ...state, open: false });
  }

  return (
    <SnackbarContext.Provider
      value={{
        show: (message, type, duration, header) =>
          setState({
            open: true,
            message,
            header,
            duration: duration || 3500,
            type,
          }),
      }}
    >
      <>
        <Snackbar
          open={state.open}
          handleClose={handleClose}
          message={state.message}
          header={state.header}
          duration={state.duration}
          type={state.type}
        />
        {children}
      </>
    </SnackbarContext.Provider>
  );
}
